module.exports = "./img/ea44347d88021fa06dab4f7ef8c6968c.jpg";